var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 180,
    viewBox: "0 0 327 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 111.3H69.6667V147H90.7778V111.3H114V91.35H90.7778V0H76L0 97.65V111.3ZM29.9778 91.35L69.6667 41.79V91.35H29.9778Z",
    fill: "#ECEAE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.42 162.9V177.132C129.42 178.716 130.704 180 132.287 180H195.236C196.819 180 198.102 178.716 198.102 177.132V162.9C198.102 161.316 196.819 160.032 195.236 160.032H132.287C130.704 160.032 129.42 161.316 129.42 162.9ZM174.856 112.572C174.856 122.856 170.334 126.768 163.138 126.768C155.941 126.768 151.419 122.856 151.419 112.572V34.776C151.419 24.48 155.941 20.58 163.138 20.58C170.334 20.58 174.856 24.492 174.856 34.776V112.572ZM224.275 4.104V3.864C224.275 2.676 223.315 1.716 222.128 1.716H206.499C205.311 1.716 204.34 2.676 204.34 3.864V4.104C204.34 10.392 199.242 15.516 192.957 15.54C187.571 5.472 177.447 0 163.138 0C148.828 0 138.716 5.472 133.318 15.528C127.033 15.504 121.935 10.392 121.935 4.092V3.852C121.935 2.664 120.964 1.704 119.776 1.704H104.147C102.96 1.716 102 2.676 102 3.864V4.104C102 19.872 113.671 32.952 128.82 35.16C128.82 35.52 128.808 35.856 128.808 36.216V111.132C128.808 134.184 140.935 147.36 163.15 147.36C185.364 147.36 197.491 134.184 197.491 111.132V36.216C197.491 35.856 197.491 35.508 197.467 35.16C212.616 32.952 224.287 19.872 224.287 4.104",
    fill: "#ECEAE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.287 111.3H281.954V147H303.065V111.3H326.287V91.35H303.065V0H288.287L212.287 97.65V111.3ZM242.265 91.35L281.954 41.79V91.35H242.265Z",
    fill: "#ECEAE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.afa8ad882d7e0a8bd467e0ea0f7921aa.svg";
export { ForwardRef as ReactComponent };